import { CORNERS, PROGRESS_SIZES } from 'vars/index'

export const Corners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_10: CORNERS.CORNERS_10,
} as const
export type Corners = (typeof Corners)[keyof typeof Corners]

export const Height = {
  SIZE_10: PROGRESS_SIZES.SIZE_10,
  SIZE_20: PROGRESS_SIZES.SIZE_20,
  SIZE_30: PROGRESS_SIZES.SIZE_30,
} as const
export type Height = (typeof Height)[keyof typeof Height]

export const Width = {
  SIZE_10: PROGRESS_SIZES.SIZE_10,
  SIZE_20: PROGRESS_SIZES.SIZE_20,
  SIZE_30: PROGRESS_SIZES.SIZE_30,
  SIZE_40: PROGRESS_SIZES.SIZE_40,
} as const
export type Width = (typeof Width)[keyof typeof Width]
